import BaseEmployeeSelector from './baseEmployeeSelector';
class MultiEmployeeSelector extends BaseEmployeeSelector {
  constructor(
    formElementGuid,
    formElementName,
    template,
    employeeData,
    prefilledEmployees,
    placeholderText,
    noResultLabel,
    personalNumberLabel,
    nameLabel,
    emailLabel,
    phoneLabel,
    phoneCountryCodeLabel,
    newEmployeeLabel
  ) {
    super({
      formElementGuid,
      formElementName,
      selectorElementId: `employee-dropdown-${formElementGuid}`,
      valueInputId: formElementGuid,
      employeeData,
      placeholderText,
      noResultLabel
    });
    this.template = template;
    this.personalNumberLabel = personalNumberLabel;
    this.nameLabel = nameLabel;
    this.emailLabel = emailLabel;
    this.phoneLabel = phoneLabel;
    this.phoneCountryCodeLabel = phoneCountryCodeLabel;
    this.newEmployeeLabel = newEmployeeLabel;

    this.employeeCount = employeeData.length - 1;
    this.employeeInputContainer = document.getElementById(
      `employee-inputs-container-${formElementGuid}`
    );
    this.addNewButton = document.getElementById(`add-new-${formElementGuid}`);
    this.loading = false;
    this.openingPrevented = false;
    this.prefilledEmployees = prefilledEmployees || [];
  }

  init() {
    super.init();
    this.attachEventHandlers();
  }
  load(data, initialLoad = false) {
    if (initialLoad && this.prefilledEmployees.length > 0) {
      // Combine arrays, giving precedence and order to prefilledEmployees
      const employeeMap = new Map();

      // First, add all from prefilledEmployees (highest precedence and order)
      this.prefilledEmployees.forEach(emp => {
        employeeMap.set(emp.personalNumber, emp);
      });

      // Then, add all from data (only if not already present)
      data.forEach(emp => {
        if (!employeeMap.has(emp.personalNumber)) {
          employeeMap.set(emp.personalNumber, emp);
        }
      });

      const unique = Array.from(employeeMap.values());
      super.load(unique);
    }
    else {
      super.load(data);
    }
    this.renderInputsOfEmployees();
    this.loadInputContainer();
  }
  attachEventHandlers() {
    let selectContainer = $(this.selectorElement);
    selectContainer.on("select2:select", (e) => {
      const employee = this.getEmployee(e.params.data.element.dataset.personalNumber);
      this.onEmployeeSelected(employee);
    });
    selectContainer.on("select2:unselect", (e) => {
      this.loadInputContainer();
      this.setValues();
      this.removeManualOption(e);
    });
    selectContainer.on("onblur", (e) => {
      this.setValues();
    });
    this.addNewButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.addEmployee();
      this.loadInputContainer();
    });
  }
  onEmployeeSelected(employee) {
    this.loadInputContainer();
    this.setValues();
    super.setExtraEmploymentData(employee.personalNumber, employee.countryCode, `input[id="${employee.baseId}_email"]`, `input[id="${employee.baseId}_phone"]`);
  }
  clear(isInitialLoad = false) {
    document.getElementById(`counter_${this.formElementGuid}`).innerHTML = '';
    super.clear(isInitialLoad);
  }
  loadSelect2() {
    const noResultLabel = this.noResultLabel;
    $(this.selectorElement).select2({
      templateResult: (data) => $(data.element).text(),
      templateSelection: (data) => $(data.element).text(),
      placeholder: this.placeholder,
      allowClear: true,
      width: '100%',
      language: {
        noResults: function (params) {
          return noResultLabel
        }
      }
    });
    this.loading = false;
  }

  removeManualOption(e) {
    const option = e.params.data.element;
    if (option.dataset.fromapi === "false") {
      option.remove();
    }
  }


  setValues() {
    let values = "";
    $(this.selectorElement)
      .val() // Taking selected values
      .forEach((index) => {
        // get containing div
        let inputsDiv = document.getElementById(
          `${this.formElementGuid}_${index}_inputs`
        );
        if (inputsDiv && inputsDiv.classList.contains("manual-inputs")) {
          // get all inputs
          let inputs = inputsDiv.querySelectorAll("input.multi-employee-input");
          // create value string starting with the index
          let value = `${index};`;
          inputs.forEach(function (input) {
            // append each input value in the container to the value string
            value += input.value + ";";
          });
          // add delimited to value collection representing each selected input container
          values += value.slice(0, -1) + "|";
        }
      });
    this.valueInput.value = values.slice(0, -1);
  }

  renderInputsOfEmployees() {
    // Render existing employees
    this.employeeInputContainer.innerHTML = "";
    this.employees.forEach((employee, index) => {
      this.addInputs(index, employee, "beforeend", false);
      this.addValidation();
    });
  }

  addInputs(index, employee, insertPosition, show = false) {
    const baseId = `${this.formElementGuid}_${index}`;
    const baseName = `${this.formElementName}_${index}`;
    const hasName = employee?.name && employee?.name != '';
    const hasPersonalNumber = employee?.personalNumber && employee?.personalNumber != '';

    const { InternationalPhoneNumber } = window.FalckComponents;
    const internationalPhoneNumber = new InternationalPhoneNumber(`${baseId}_phone`, `${baseName}_phone`);
    let dialCode = "46";
    let phoneNumber = null;

    if (employee?.phone && employee?.phone.trim() !== "") {
      let formattedValue = employee?.phone.trim();
      if (formattedValue.startsWith("00")) {
        formattedValue = formattedValue.substring(2);
      }

      if (formattedValue.length > 2) {
        dialCode = formattedValue.substring(0, 2);
        phoneNumber = formattedValue.substring(2);
      }
    }
    const phoneHtml = internationalPhoneNumber.generateHtml('phone-template', {
      baseId: `${baseId}_phone`,
      countrycodelabel: this.phoneCountryCodeLabel,
      label: this.phoneLabel,
      dialCode: dialCode,
      phoneNumber: phoneNumber,
    });

    const html = this.template
      .replace(/{{baseId}}/g, baseId)
      .replace(/{{baseName}}/g, baseName)
      .replace(/{{name}}/g, employee?.name || "")
      .replace(/{{personalNumber}}/g, employee?.personalNumber || "")
      .replace(/{{countryCode}}/g, employee?.countryCode || "")
      .replace(/{{email}}/g, employee?.email || "")
      .replace(/{{phone}}/g, employee?.phone || "")
      .replace(/{{nameValidation}}/g, hasName ? "ValidationSuccess" : "")
      .replace(/{{personalNumberValidation}}/g, hasPersonalNumber ? "ValidationSuccess" : "")
      .replace(/{{nameReadOnly}}/g, hasName ? "readonly" : "")
      .replace(/{{personalNumberReadOnly}}/g, hasPersonalNumber ? "readonly" : "")
      .replace(/{{containerCss}}/g, show === true ? "" : "hidden")
      .replace(/{{phoneHtml}}/g, phoneHtml)
      .replace(/{{personalNumberLabel}}/g, this.personalNumberLabel)
      .replace(/{{nameLabel}}/g, this.nameLabel)
      .replace(/{{emailLabel}}/g, this.emailLabel);

    this.employeeInputContainer.insertAdjacentHTML(insertPosition, html);
    internationalPhoneNumber.addEventListeners();
  }

  populateSelector(employees) {
    employees.forEach((employee, index) => {
      const isPrefilled = this.prefilledEmployees?.some(prefilled => prefilled.personalNumber === employee.personalNumber);
      this.addOptionToSelector(index, employee, isPrefilled, false);
    });

    this.loadSelect2(this.placeholder);
  }

  loadInputContainer() {
    var selected = $(this.selectorElement).val();
    const allValues = Array.from(this.selectorElement.options).map(
      (option) => option.value
    );
    let counter = 1;
    allValues.forEach((index) => {
      const baseId = `${this.formElementGuid}_${index}`;
      const inputsDivId = `${baseId}_inputs`;
      const inputDiv = document.getElementById(inputsDivId);
      if (inputDiv) {
        const isSelected = selected.includes(index);

        if (!!isSelected) {
          inputDiv.classList.remove("hidden");
        } else {
          inputDiv.classList.add("hidden");
        }

        if (!!isSelected) {
          this.updateHeading(baseId, counter);
          counter++;
        }
      }
    });
  }

  addEmployee(employee) {
    this.employeeCount++;
    this.employees.push(employee);
    this.addOptionToSelector(this.employeeCount, employee, true, true);
    this.addInputs(this.employeeCount, employee, "afterbegin", true);
    this.addValidation();

    const baseId = `${this.formElementGuid}_${this.employeeCount}`;
    document
      .getElementById(`${baseId}_name`)
      .addEventListener("input", () => {
        this.updateHeading(baseId);
      });
    document
      .getElementById(`${baseId}_personalNumber`)
      .addEventListener("input", () => {
        this.updateHeading(baseId);
      });
  }

  updateHeading(baseId, index = null) {
    if (index === null) {
      index = document.getElementById(`${baseId}_heading`).dataset.index;
    }
    this.updateOptionText(baseId);
    this.updateInputHeading(baseId, index);
    this.updateCounter(index);

    $(this.selectorElement).trigger("change")
  }

  updateCounter(index) {
    document.getElementById(`counter_${this.formElementGuid}`).innerHTML = `(${index})`;
  }

  updateInputHeading(baseId, index) {
    const name = document.getElementById(`${baseId}_name`)?.value?.trim();

    let heading = document.getElementById(`${baseId}_heading`);
    heading.dataset.index = index;
    heading.innerHTML = `${index}. ${!!name?.trim() ? name : this.newEmployeeLabel}`;
  }

  updateOptionText(baseId) {
    const name = document.getElementById(`${baseId}_name`)?.value?.trim();
    const personalNumber = document.getElementById(`${baseId}_personalNumber`)?.value?.trim();

    const option = this.selectorElement.querySelector(`option[id="${baseId}_option"]`);
    const optionText = !!personalNumber
      ? `${name} (${personalNumber})`
      : name;
    option.text = !!optionText ? optionText : this.newEmployeeLabel;
  }

  addValidation() {
    document.querySelectorAll(".manual-inputs input").forEach((input) => {
      input.addEventListener("blur", (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        const hasValue = value.trim().length !== 0;
        let validationElement = document.getElementById(`${name}_desc`);
        if (validationElement != null) {
          if (hasValue) {
            validationElement.style.setProperty("display", "none", "important");
          } else {
            validationElement.style.setProperty(
              "display",
              "block",
              "important"
            );
          }
        }
        this.setValues();
      });
    });
  }
}

window.FalckComponents = {
  ...window.FalckComponents,
  MultiEmployeeSelector: MultiEmployeeSelector,
};
